import React from "react";
import classes from "./index.module.scss";
import Header from "components/Header";
import classNames from "classnames";
import { Breadcrumb } from "antd";

interface DetailLayoutProps {
    children: React.ReactNode;
    breadcrumb?: React.ReactNode;
}

export default function DetailLayout({
    children,
    breadcrumb
}: DetailLayoutProps) {
    return (
        <div className={classNames(classes.root, "PopupContainer")}>
            <Header />

            <div className={classes.main}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>监考列表</Breadcrumb.Item>

                    {typeof breadcrumb === "string" ? (
                        <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                    ) : (
                        breadcrumb
                    )}
                </Breadcrumb>
                <div className={classes.body}>{children}</div>
            </div>
        </div>
    );
}
